export const filterOptions = (
  userMap: Map<string, { email: string; name: string }>,
  inputValue: string,
) => {
  const filteredUsers = [];

  userMap.forEach((user, key) => {
    if (key.includes(inputValue.toLowerCase())) {
      filteredUsers.push(user);
    }
  });
  if (filteredUsers.length >= 10) return filteredUsers.slice(0, 10);
  return filteredUsers;
};
